// src/components/ForgotPasswordRequest.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "../css/FormStyles.css";

const ForgotPasswordRequest = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch CSRF token on mount
  useEffect(() => {
    axios.get("/api/csrf/", { withCredentials: true })
      .then(() => console.log("CSRF token set."))
      .catch(() => setError("Failed to set CSRF token."));
  }, []);

  // Handle form submission
  const handleRequest = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      const csrfToken = Cookies.get("csrftoken");
      const res = await axios.post(
        "/api/reset-password-email/",
        { email },
        {
          headers: { "X-CSRFToken": csrfToken },
          withCredentials: true,
        }
      );

      setMessage(res.data.message || "Check your email for the reset link.");
      setEmail("");

      // Redirect to login after short delay
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <form onSubmit={handleRequest} className="login-form">
        <h2>Forgot Password</h2>

        <div className="form-group">
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <button type="submit" className="signin" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
    </div>
  );
};

export default ForgotPasswordRequest;

